const theme = {
    colors: {
        primary: "#2D82B7",
        secondary: "#07004D",
        accent: "#42E2B8",
        warning: "#EB8A90",
        tertiary: "#F3DFBF",
        disabled: {
            primary: "#2D82B7",
            secondary: "#07004D",
            accent: "#42E2B8",
            warning: "#EB8A90",
            tertiary: "#F3DFBF",
        },
        hover: {
            primary: "#2D82B7",
            secondary: "#07004D",
            accent: "#42E2B8",
            warning: "#EB8A90",
            tertiary: "#F3DFBF",
        },
    },
};

export default theme;
